import { Image, Link, Text, View } from "@react-pdf/renderer";
import React from "react";
import { format } from "date-fns";
import { Images } from "../../assets";
import { CreateBillDto } from "../../model/bill/dto/CreateBillDto";
import { UpdateBillDto } from "../../model/bill/dto/UpdateBillDto";
import { Bill } from "../../model/bill/types/Bill";

type PDFHeaderProps = {
  dto: CreateBillDto | UpdateBillDto | Bill;
};

export const PDFHeader: React.FC<PDFHeaderProps> = ({ dto }) => {
  const { soldTo } = dto;

  return (
    <View
      style={{
        flexDirection: "column",
        width: "100%",
        gap: "12px",
      }}
    >
      <View
        style={{
          flexDirection: "row",
          alignItems: "flex-end",
        }}
      >
        <View style={{ flexGrow: 2, gap: "5px" }}>
          <View style={{ flexDirection: "row", gap: "5px" }}>
            <Image cache style={{ width: "15%" }} src={Images.IconLogo} />
            <View
              style={{
                gap: "5px",
                flexDirection: "row",
                alignItems: "flex-end",
              }}
            >
              <Text style={{ color: "green" }}>SHAM</Text>
              <Text style={{ color: "purple" }}>IMPORT EXPORT</Text>
              <Text style={{ color: "blue" }}>LTD</Text>
            </View>
          </View>

          <View style={{ gap: "3px" }}>
            <Text>8423 165 ST SURREY, BC, V4N 3H3, Canada</Text>
            <Text style={{ color: "gray" }}>ahmad.aryan83@gmail.com</Text>
            <Text>TEL: +1 (236)-888-2596</Text>
            <Link href="https://www.shamautoparts.com">
              www.shamautoparts.com
            </Link>
          </View>
        </View>

        <View style={{ justifyContent: "flex-end" }}>
          <View
            style={{
              gap: "3px",
              flexGrow: 1,
            }}
          >
            <Text style={{ color: "red" }}>INVOICE</Text>
            <Text>INVOICE NO: {(dto as Bill).billNumber}</Text>
            <Text>INVOICE DATE: </Text>
            <Text style={{ color: "red" }}>M.D.Y</Text>
            <Text>
              {format(new Date((dto as CreateBillDto).invoiceDate), "L.d.y")}
            </Text>
            <Text>GST NO: 799477930 RT0001</Text>
          </View>
        </View>
      </View>

      {/*  */}
      <View style={{ marginBottom: 20, marginTop: 3 }}>
        <Text style={{ fontWeight: "bold" }}>SOLD TO: {soldTo}</Text>
      </View>
    </View>
  );
};
